const KEYS = ['tx', 'ty', 'tz', 'rx', 'ry', 'rz', 'sx', 'sy', 'sz'];

export const TRANSFORM_DEFAULT = {
  tx: 0, ty: 0, tz: 0,
  rx: 0, ry: 0, rz: 0,
  sx: 1, sy: 1, sz: 1,
};

/**
 * Encode a transformation object to a compact comma-separated string.
 * "tx,ty,tz,rx,ry,rz,sx,sy,sz"
 */
export function encodeTransform(vals) {
  return KEYS.map(k => {
    const v = vals?.[k] ?? TRANSFORM_DEFAULT[k];
    return Number.isFinite(v) ? v : TRANSFORM_DEFAULT[k];
  }).join(',');
}

/**
 * Decode a compact string back to a transformation object.
 * Falls back to TRANSFORM_DEFAULT for missing or invalid fields.
 */
export function decodeTransform(str) {
  const result = { ...TRANSFORM_DEFAULT };
  if (!str) return result;
  const parts = String(str).split(',');
  KEYS.forEach((k, i) => {
    const n = parseFloat(parts[i]);
    if (Number.isFinite(n)) result[k] = n;
  });
  return result;
}

/**
 * Combine two already-encoded transformation strings into a single path-segment string.
 * Format: "<pointsStr>~<gsStr>"
 */
export function encodePair(pointsStr, gsStr) {
  return `${pointsStr ?? ''}~${gsStr ?? ''}`;
}

/**
 * Decode a combined path-segment string into two transformation objects.
 * Returns { point, gs } where each is a full transformation values object.
 */
export function decodePair(str) {
  const [pointsStr, gsStr] = (str ?? '').split('~');
  return {
    point: decodeTransform(pointsStr),
    gs:    decodeTransform(gsStr),
  };
}
